import AnalysisCollection from "@/collections/lab/AnalysisCollection";
import InstrumentCollection from "@/collections/lab/InstrumentCollection";
import InstrumentModel from "@/models/lab/InstrumentModel";
import LabServiceModel from "@/models/LabServiceModel";
import TestProcessModel from "@/models/lab/TestProcessModel";
import PrepTaskModel from "./PrepTaskModel";
import TestTaskCollection from "@/collections/lab/TestTaskCollection";

export default class TestTaskModel extends LabServiceModel {
  modelName() {
    return 'test-task';
  }
  icon() {
    return 'vial';
  }
  isPrep() {
    return false;
  }
  schedulableTaskType() {
    return 'App\\Models\\TestTask';
  }
  defaults() {
    return {
      id: null,
      parent_id: null,
      parent: null,
      test_process_id: null,
      test_process: null,
      required_prep_task_id: null,
      required_prep_task: null,
      required_test_task_id: null,
      required_test_task: null,
      name: null,
      description: null,
      group: 0,
      order: 0,
      inspecific_scheduling: 0,
      result_type: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      test_task_analyses: [],
      analyses: [],
      instruments: [],
      children: [],
    };
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      test_process_id: (val) => (this.nullStringMutator(val)),
      instrument_id: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
  getTestProcess() {
    return this.getRelatedModel(TestProcessModel, 'test_process');
  }

  getParent() {
    return this.getRelatedModel(TestTaskModel, 'parent');
  }

  getRequiredPrepTask() {
    return this.getRelatedModel(PrepTaskModel, 'required_prep_task');
  }

  getRequiredTestTask() {
    return this.getRelatedModel(TestTaskModel, 'required_test_task');
  }

  getInstruments() {
    return this.getRelatedCollection(new InstrumentCollection(), 'instruments');
  }
  
  getAnalyses() {
    return this.getRelatedCollection(new AnalysisCollection(), 'analyses');
  }

  getChildren() {
    return this.getRelatedCollection(new TestTaskCollection(), 'children');
  }
}
